import React, { useEffect, useState, useMemo, useRef } from 'react'
import { GridSelectionHLPure, CheckBoxHLPure, DialogPdf, TooltipHLPure, InputHLPure, TextAreaHLPure } from '../../pures'
import { Grid, useMediaQuery } from '@material-ui/core'
import PdfReader from '../../pures/adobePfdReader/PdfReader'
import { useTranslation } from 'react-i18next'
import { b64toBlob } from '../../../validators'
import { PDFDocument } from 'pdf-lib'
import './signature-package-request-profile.css'
import { ConvertDocumentService } from '../../../services'
import { ArrowBtnMobile } from '../../../assets/logos/icons'
import { PDFUtil } from '../../../utils'

const SiganturePackageRequestProfileView = (props) => {
  let {
    signatureProfileSelected,
    selectedFileBase64,
    handleFile,
    setProfilesDocumentInPackage,
    profilesDocuments,
    pdfToBase64,
    selectedFileName,
    selectedFile,
    nameSignature,
    onChangeNameSignature,
    errorCurrentNameSignature,
    comments,
    onChangeComments,
    errorCurrentComments,
    isExternalSignature,
    acceptDocumentError,
    // removed unused props: open, onClose, missingFields
  } = props

  const { t } = useTranslation()
  const inputFileRef = useRef(null)

  let profileDoc = [{ documentName: '', document: {} }]
  const [profiles, setProfiles] = useState(profileDoc)
  const [fileSelected, setFileSelected] = useState('')
  const [blobUrl, setBlobUrl] = useState('')
  // removed unused modalTermsCond state
  const [isMulitpleSignature, setIsMulitpleSignature] = useState(false)
  // removed unused heightGrid state
  const [tooltipDesc, setTooltipDesc] = useState('')
  const [dataItemSelected, setDataItemSelected] = useState({})
  // removed invalid filename modal and regex; validation happens on Continue in wrapper

  const uploadFile = (ref, dataItem) => {
    setDataItemSelected(dataItem)
    ref.current.click()
  }

  const pdf = useMemo(() => <PdfReader className='pdfReader' awsURL={!fileSelected} url={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_DEFAULT_PDF}`} file={fileSelected} isFile={!!fileSelected} src={fileSelected && `data:application/pdf;base64,${fileSelected}`}  ></PdfReader>, [fileSelected])

  const headerColumnOne = (props) => {
    return <span className='siganturePackageRequestProfileView-header-cell-one'>{props.title}</span>
  }

  const headerColumnTwo = (props) => {
    return <span className='siganturePackageRequestProfileView-header-cell-two'>{props.title}</span>
  }

  const cellColumnOne = (props) => {
    let subtitle = (props.dataItem.upload && props.dataItem.upload !== '') ? t('siganturePackageRequestProfileView.status.registered') : t('siganturePackageRequestProfileView.status.pending')
    return (
      <td className={`siganturePackageRequestProfileView-cell-one ${props.dataItem.selected ? 'siganturePackageRequestProfileView-cell-selected' : ''}`} onClick={(e) => onSelectRow(e, props.dataItem)}>
        <div className=''>
          <div className='contractingRegistrationDocumentsView-container-span'>
            <span className='contractingRegistrationDocumentsView-span-name'>
              {props.dataItem.documentName}
            </span>
          </div>
          <div>
            <span>
              {subtitle}
            </span>
          </div>
        </div>
      </td>
    )
  }

  const cellColumnTwo = (props) => {
    return (
      <td className={`documentPansiganturePackageRequestProfileViewelBarExpediente-cell-two ${props.dataItem.selected ? 'siganturePackageRequestProfileView-cell-selected' : ''}`} onClick={(e) => onSelectRow(e, props.dataItem)}>
        {!isExternalSignature &&
          <>
            <div className='documentPansiganturePackageRequestProfileViewelBarExpediente-custom-input-upload-file-grid' onClick={() => uploadFile(inputFileRef, props.dataItem)}>
              <p>{t('siganturePackageRequestProfileView.btn.upload')}</p>
            </div>
            <div
              className='cellActions-mobileExpanded'
              onClick={() => uploadFile(inputFileRef, props.dataItem)}
            >
              <img
                className='cellActions-icon-arrow'
                alt={'cellActions-arrow'}
                src={ArrowBtnMobile}
              />
            </div>
          </>
        }
      </td>
    )
  }

  useEffect(() => {
    let documentProfiles = []
    let isMulitpleSignature = false
    let tooltipDesc = ''
    if (!signatureProfileSelected || !signatureProfileSelected.documentProfile || !signatureProfileSelected.documentProfile.documentProfile || signatureProfileSelected.documentProfile.documentProfile.length === 0) {
      let dataDocument = {
        checked: true,
        document: {},
        documentName: selectedFileName,
        id: 0,
        signersNum: 0,
        upload: ''
      }

      if (selectedFileName && selectedFile && selectedFileName !== 'No se ha seleccionado ningún archivo') {
        let now = new Date()
        let dateString = now.toString()
        dataDocument.upload = dateString
      }

      documentProfiles.push(dataDocument)
      tooltipDesc = t('siganturePackageRequestProfileView.tooltip.desc.single')

    } else {
      if (profilesDocuments && profilesDocuments.length > 0) {
        documentProfiles = profilesDocuments
      } else {
        documentProfiles = signatureProfileSelected.documentProfile.documentProfile.sort((a, b) => {
          if (a.documentName < b.documentName) return -1
          if (a.documentName > b.documentName) return 1
          return 0
        })

          .map((documentProfile) => {
            documentProfile.document = {}
            return documentProfile
          })
      }

      isMulitpleSignature = true
      tooltipDesc = t('siganturePackageRequestProfileView.tooltip.desc')
    }

    setIsMulitpleSignature(isMulitpleSignature)
    setTooltipDesc(tooltipDesc)
    setProfiles(documentProfiles)
  }, [signatureProfileSelected, profilesDocuments, selectedFile, selectedFileName, t])

  useEffect(() => {
    if (props.documentsAssembly && props.documentsAssembly.length > 0) {
      setProfiles(props.documentsAssembly)
    }
  }, [props.documentsAssembly])

  useEffect(() => {
    if (selectedFileBase64) {
      const blob = b64toBlob(selectedFileBase64, 'application/pdf')
      setBlobUrl(blob)
      setFileSelected(selectedFileBase64)
    }
  }, [selectedFileBase64])

  useEffect(() => {
    const scrollableContainer = document.querySelector('.siganturePackageRequestProfileView-grid-scrollable')
    if (!scrollableContainer) return

    if (profiles.length > 5) {
      scrollableContainer.style.maxHeight = '455px'
      scrollableContainer.style.border = '1px solid #d3d3d3'
    } else {
      scrollableContainer.style.maxHeight = 'none'
      scrollableContainer.style.border = 'none'
    }
  }, [profiles])

  const handleNameSignatureChange = (e) => {
    onChangeNameSignature(e)
  }

  const handleFileSingleDocument = (e) => {
    const file = e.target.files[0]

    if (!file) return


    //Add name if is simple signature
    let copyProfiles = [...profiles]
    let now = new Date()
    let dateString = now.toString()
    copyProfiles[0].documentName = file.name
    copyProfiles[0].upload = dateString
    setProfiles(copyProfiles)
    handleFile(e)
    if (inputFileRef.current) {
      inputFileRef.current.value = ''
    }
  }

  const handleFileDoc = async (e) => {
    if (!e || !e.target || !e.target.files || !e.target.files[0]) return

    const file = e.target.files[0]


    let convertDocumentService = new ConvertDocumentService(process.env.REACT_APP_MIFIRMA_API)
    let fileBase64 = await pdfToBase64(e.target.files[0])

    let pdfDoc = await PDFDocument.load(fileBase64)
    const { hadError, PDFDocument: pdfReturned } = PDFUtil.fixPageType(pdfDoc)
    pdfDoc = pdfReturned
    if (hadError) {
      fileBase64 = await pdfDoc.saveAsBase64()
    }
    const author = pdfDoc.getAuthor()
    const creator = pdfDoc.getCreator()
    const pages = pdfDoc.getPages()
    let fileSplitted
    if (author === '' && creator === '' && pages <= 35) {
      let data = new FormData()
      data.append('doc', file)
      let pdfConverted = await convertDocumentService.convertDocumentPDF(props.token, data)
      const convertedBlob = new Blob([new Uint8Array(pdfConverted.data).buffer], { type: 'application/pdfbase64' })
      let convertedBase64 = await pdfToBase64(convertedBlob)
      fileSplitted = convertedBase64.split(',')[1]
    }

    let pdfBase64 = fileBase64.split(',')[1]

    let documentProfiles = [...signatureProfileSelected.documentProfile.documentProfile]
    let newProfiles = documentProfiles.map((profile) => {
      if (profile.documentName === dataItemSelected.documentName) {
        profile.document.name = file.name
        profile.document.file = file
        profile.selected = true
        profile.upload = true
        profile.url = fileSplitted ?? pdfBase64
      } else {
        profile.selected = false
      }
      return profile
    })
    setProfiles(newProfiles)
    setProfilesDocumentInPackage(newProfiles)

    handleFile(e)
    if (inputFileRef.current) {
      inputFileRef.current.value = ''
    }
  }

  const isMobile = useMediaQuery('(max-width:560px)')

  const onSelectRow = (e, dataItem) => {
    if (isExternalSignature) {
      if (dataItem && dataItem.url) {
        const blob = b64toBlob(dataItem.url, 'application/pdf')
        setBlobUrl(blob)
        setFileSelected(dataItem.url)
      }
    } else {
      let url = (dataItem && dataItem.url) ? dataItem.url : ''
      if (url) {
        const blob = b64toBlob(url, 'application/pdf')
        setBlobUrl(blob)
        setFileSelected(url)
      }
    }
  }

  return (
    <>
      <div style={props.selectedFile && props.selectedFileBase64 && { marginBottom: 0 }} className='siganturePackageRequestProfileView-container-documents'>
        <div className='siganturePackageRequestProfileView-panels-container'>
          <InputHLPure
            labelInput={t('signatureRequestView2.toolTipFirst')}
            typeInput={'text'}
            valueInput={nameSignature}
            handleChangeInput={handleNameSignatureChange}
            errorInput={errorCurrentNameSignature}
            errorInputText={t('signatureRequestProfileData.nameSignature')}
            informationIcon
            tooltipShow
            positionTooltip={isMobile ? 'top' : 'right'}
            titleTooltip={t('signatureRequestView2.toolTipFirst')}
            descriptionTooltip={t('signatureRequestView2.tooltipFirstDetail')}
            inputActive
            characterLimit={128}
          />
          <TextAreaHLPure
            labelTextArea={t('signatureRequestView2.addComments')}
            valueTextData={comments || ''}
            handleChangeTextArea={(e) => onChangeComments(e)}
            errorInput={errorCurrentComments}
            errorTextArea={t('signatureRequestProfileData.notes')}
            tooltipShow
            informationIcon
            positionTooltip={isMobile ? 'top' : 'right'}
            titleTooltip={t('signatureRequestView2.addComments')}
            descriptionTooltip={t('signatureRequestView2.tooltipCommentsDescription')}
            characterLimit={500}
          />
          <div className='siganturePackageRequestProfileView-docs-sign'>
            <div className='siganturePackageRequestProfileView-docs-sign-title'>
              <p className='siganturePackageRequestProfileView-label-title'>{t('siganturePackageRequestProfileView.title')}</p>
              <div className='siganturePackageRequestProfileView-tooltip'>
                <TooltipHLPure
                  positionTooltip={isMobile ? 'top' : 'right'}
                  titleTooltip={t('siganturePackageRequestProfileView.title')}
                  descriptionTooltip={tooltipDesc}
                  informationIcon={true}
                />
              </div>
            </div>
            <div className='siganturePackageRequestProfileView-grid-wrapper'>
              <div className='siganturePackageRequestProfileView-grid-scrollable'>
                <GridSelectionHLPure
                  styleGeneral={true}
                  styleGeneralClass={'siganturePackageRequestProfileView-general-grid'}
                  pageable={false}
                  skip={0}
                  take={profiles.length}
                  dataGrid={profiles}
                  filter={false}
                  columnTwo={true}
                  titleRow1={t('signatureRequestProfile.col1.title')}
                  titleRow2={t('signatureRequestProfile.col4.title')}
                  headerColumnOne={headerColumnOne}
                  headerColumnTwo={headerColumnTwo}
                  cellColumnOne={cellColumnOne}
                  cellColumnTwo={cellColumnTwo}
                />
              </div>
            </div>
          </div>
        </div>
        <>
          <div className='siganturePackageRequestProfileView-documentPDF-container'>
            {pdf}
          </div>
          {
            fileSelected && (
              <div className='siganturePackageRequestProfileView-pdf-mobile'>
                <DialogPdf blobUrl={blobUrl} />
              </div>
            )
          }
        </>
      </div>
      {props.selectedFile && props.selectedFileBase64 && (
        <div
          container
          xs={12}
          lg={12}
          md={12}
          sm={12}
          className='container-checkbox-confirm-request'
        >
          <Grid>
          </Grid>
          <Grid
            item
            xs={12}
          >
            <div className='signaturePackAageRequestProfileView-container-checkBox'>
              <CheckBoxHLPure
                labelCheckBox={t('siganturePackageRequestProfileView.acceptUploadDocumentLegal')}
                valueCheckBox={props.documentAccept}
                idCheckBox={'document'}
                onChangeHandler={props.handleChangeCheckbox}
                checkedState={props.documentAccept}
              />
              <>
                {acceptDocumentError && (
                  <span className='hint-message-error'>
                    {t('signatureRequestView2.acceptUploadDocument')}
                  </span>
                )}
              </>
            </div>
          </Grid>
        </div>
      )}


      <input
        ref={inputFileRef}
        onChange={(isMulitpleSignature) ? (e) => handleFileDoc(e) : (e) => handleFileSingleDocument(e)}
        type='file'
        id='fileToSign'
        accept='application/pdf'
        style={{ display: 'none' }}
      />
    </>
  )
}

export { SiganturePackageRequestProfileView as default }